import { defineStore } from 'pinia'
import { ref } from 'vue'
const appStore = defineStore(
	'appStore',
	() => {
		const lang = ref('')// 语言(zh-CN|en-US)
		const appInfo: any = ref({
			token: '',
			cnty: 0, // 国家
			lat: 0, // 纬度
			lon: 0, // 经度
			userInfo: {}, // 用户信息
			deviceInfo: {}, // 设备信息
			topHeight: 0, // 顶部高度
			isApp: false // 是否是app
		})
		// 设置appInfo
		const setAppInfo = (key: string, val: any) => {
			appInfo.value[key] = val
		}

		return {
			lang,
			appInfo,
			setAppInfo,
		}
	},
	{
		// persist: false, // 如果不想开启，直接false即可，不要添加配置
		persist: {
			storage: localStorage, // 缓存使用方式
			pick: ['appInfo', 'lang'] // 需要缓存键，为空缓存全部，不为空缓存对应的键
		}
	}
)
export default appStore
